/* The Doggie Shop — landing interactions */
(function () {
  'use strict';
  if (window.__tdsBooted) { return; }
  window.__tdsBooted = true;

  function reveal() {
    var els = document.querySelectorAll('.tds-r:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting || e.boundingClientRect.top < 0) {
          e.target.classList.add('is-in'); io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });

    // Safety net: instant jumps (anchors, restored scroll) can bypass the observer.
    if (!window.__tdsSweep) {
      window.__tdsSweep = true;
      var ticking = false;
      var sweep = function () {
        ticking = false;
        var vh = window.innerHeight || 0;
        document.querySelectorAll('.tds-r:not(.is-in)').forEach(function (el) {
          if (el.getBoundingClientRect().top < vh * 0.92) el.classList.add('is-in');
        });
      };
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(sweep);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      setTimeout(sweep, 400);
    }
  }

  function rails() {
    document.querySelectorAll('[data-tds-rail]').forEach(function (wrap) {
      var rail = wrap.querySelector('.tds-rail');
      if (!rail || rail.dataset.bound) return;
      rail.dataset.bound = '1';
      wrap.querySelectorAll('[data-rail-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = rail.querySelector('.tds-card');
                    var step = card ? card.offsetWidth + parseFloat(getComputedStyle(rail).columnGap || 0) : 300;
          rail.scrollBy({ left: btn.dataset.railDir === 'next' ? step : -step, behavior: 'smooth' });
        });
      });
    });
  }

  function counters() {
    var nodes = document.querySelectorAll('[data-count]');
    if (!nodes.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target; io.unobserve(el);
        var target = parseFloat(el.dataset.count) || 0;
        var suffix = el.dataset.suffix || '';
        var dec = (el.dataset.dec | 0);
        var start = null, dur = 1500;
        function tick(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (target * eased).toFixed(dec) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.5 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  function quiz() {
    document.querySelectorAll('[data-tds-quiz]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      var steps = root.querySelectorAll('.tds-q');
      var bars = root.querySelectorAll('.tds-steps i');
      var results = root.querySelectorAll('.tds-res');
      var picks = [];

      function show(idx) {
        steps.forEach(function (s, i) { s.classList.toggle('on', i === idx); });
        bars.forEach(function (b, i) { b.classList.toggle('on', i <= idx); });
      }

      function finish() {
        var score = {};
        picks.forEach(function (p) {
          p.split(',').forEach(function (k) {
            k = k.trim(); if (!k) return;
            score[k] = (score[k] || 0) + 1;
          });
        });
        var best = null, bestN = -1;
        Object.keys(score).forEach(function (k) { if (score[k] > bestN) { bestN = score[k]; best = k; } });
        var matched = false;
        results.forEach(function (r) {
          var on = r.dataset.key === best;
          r.classList.toggle('on', on);
          if (on) matched = true;
        });
        if (!matched && results[0]) results[0].classList.add('on');
        steps.forEach(function (s) { s.classList.remove('on'); });
        bars.forEach(function (b) { b.classList.add('on'); });
        var top = root.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }

      root.querySelectorAll('.tds-opt').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.closest('.tds-q').dataset.step, 10);
          picks[step] = btn.dataset.tags || '';
          if (step + 1 < steps.length) show(step + 1); else finish();
        });
      });

      root.querySelectorAll('.tds-restart').forEach(function (b) {
        b.addEventListener('click', function () {
          picks = [];
          results.forEach(function (r) { r.classList.remove('on'); });
          show(0);
        });
      });

      show(0);
    });
  }

  function boot() { reveal(); rails(); counters(); quiz(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
/* ── TDS quiz: name & breed pre-step + personalised results (appended 2026-09-19) ── */
(function(){
  function tcase(s){s=s.trim().replace(/[<>&"']/g,'').slice(0,24);return s?s.charAt(0).toUpperCase()+s.slice(1):''}
  function init(){
    document.querySelectorAll('[data-tds-quiz]').forEach(function(card){
      if(card.dataset.namestep)return;card.dataset.namestep='1';
      var qs=card.querySelectorAll('.tds-q h3');
      if(qs[0])qs[0].textContent="What's bugging your dog?";
      var pre=document.createElement('div');pre.className='tds-q0';
      var h=document.createElement('h3');h.textContent='First things first — who are we shopping for?';
      var row=document.createElement('div');row.className='tds-q0-row';
      var nameIn=document.createElement('input');nameIn.className='tds-q0-in';nameIn.placeholder="Dog's name";nameIn.maxLength=24;nameIn.autocomplete='off';nameIn.setAttribute('aria-label',"Dog's name");
      var breedIn=document.createElement('input');breedIn.className='tds-q0-in';breedIn.placeholder='Breed (optional)';breedIn.maxLength=32;breedIn.autocomplete='off';breedIn.setAttribute('aria-label','Breed');
      row.appendChild(nameIn);row.appendChild(breedIn);
      var actions=document.createElement('div');actions.className='tds-q0-actions';
      var go=document.createElement('button');go.type='button';go.className='tds-btn tds-btn--gold tds-q0-go';
      var gs=document.createElement('span');gs.textContent="Let's go";go.appendChild(gs);
      var skip=document.createElement('button');skip.type='button';skip.className='tds-q0-skip';skip.textContent='Skip — straight to the questions';
      actions.appendChild(go);actions.appendChild(skip);
      pre.appendChild(h);pre.appendChild(row);pre.appendChild(actions);
      card.insertBefore(pre,card.firstChild);
      card.classList.add('tds-preq');
      function start(withName){
        var name=withName?tcase(nameIn.value):'';
        var breed=withName?tcase(breedIn.value):'';
        card.classList.remove('tds-preq');
        pre.remove();
        if(!name)return;
        if(qs[0])qs[0].textContent="What's bugging "+name+"?";
        if(qs[2]&&/how old/i.test(qs[2].textContent))qs[2].textContent='And how old is '+name+'?';
        card.querySelectorAll('.tds-res .tds-res-grid > div:last-child').forEach(function(col){
          var n=document.createElement('p');n.className='tds-match-note';
          n.textContent='Best first pick for '+name+(breed?' · '+breed:'');
          col.insertBefore(n,col.firstChild);
        });
      }
      go.addEventListener('click',function(){start(true)});
      skip.addEventListener('click',function(){start(false)});
      [nameIn,breedIn].forEach(function(i){i.addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();start(true)}})});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
/* v8: reveal failsafe (iOS Safari) */
(function(){
  try{
    document.documentElement.classList.add('tds-js');
    var mark=function(){document.querySelectorAll('.tds-r:not(.is-in)').forEach(function(el){if(el.getBoundingClientRect().top < window.innerHeight+60)el.classList.add('is-in')})};
    if(!('IntersectionObserver' in window)){document.querySelectorAll('.tds-r').forEach(function(el){el.classList.add('is-in')});return}
    setTimeout(mark,1200);
    var t;window.addEventListener('scroll',function(){if(t)return;t=setTimeout(function(){t=0;mark()},200)},{passive:true});
    window.addEventListener('pageshow',function(e){if(e.persisted)mark()});
  }catch(e){
    document.querySelectorAll('.tds-r').forEach(function(el){el.classList.add('is-in')});
  }
})();
/* v20 (18 Oct 2026): buttons under homepage rail intros.
   To add a button to another rail, add a line to RAIL_BUTTONS. */
(function(){
  var RAIL_BUTTONS=[
    {section:'tds_rail_1', label:'Shop All Supplements', href:'/collections/supplements'}
  ];
  var ARROW='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"></path></svg>';
  function addRailButtons(){
    RAIL_BUTTONS.forEach(function(b){
      var head=document.querySelector('[id$="__'+b.section+'"] .tds-head-l');
      if(!head||head.querySelector('.tds-rail-cta'))return;
      var a=document.createElement('a');
      a.className='tds-btn tds-btn--ink tds-btn--sm tds-rail-cta';
      a.href=b.href;
      a.innerHTML='<span>'+b.label+'</span>'+ARROW;
      head.appendChild(a);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',addRailButtons);else addRailButtons();
})();
